
import axios from "axios"
import router from '../../router';

import { func } from '../../main';

const state = {
    LocalUserListList: [],
    LocalUserListListForSMS: [],
    Loading:false
};


const getters = {
    GetLocalUserListList(state: { LocalUserListList: any; }) {
        return state.LocalUserListList;
    },
    GetLocalUserListForSms(state: { LocalUserListListForSMS: any; }) {
        return state.LocalUserListListForSMS;
    }
};

const mutations = {

    SetLocalUserListList(state: { LocalUserListList: any; }, list: any) {

        state.LocalUserListList = list;
    },
    SetLocalUserListForSMS(state: { LocalUserListListForSMS: any; }, list: any) {
        state.LocalUserListListForSMS = list;
    }

};

const actions = {
    GetLocalUserListListFromServerForMap(context: { commit: (arg0: string, arg1: any) => void; }, filter: { workGroupId: any; }) {

        axios.get("Task/ServerFiltering_GetUserListForMap", {
            params: {
                wId: filter.workGroupId
            }
        })
            .then((data: any) => {
                context.commit("SetLocalUserListList", data.data);
            });
    },
    GetLocalUserListListFromServer(context: { commit: (arg0: string, arg1: any) => void; }, filter: { workGroupId: any, expiredControl: false; }) {
        let expiredControl = false;
        if (filter != undefined && filter != null && filter.expiredControl != undefined && filter.expiredControl != null)
            expiredControl = filter.expiredControl;
        axios.get("Task/ServerFiltering_GetUserList", {
            params: {
                wId: filter.workGroupId,
                expiredControl: expiredControl
            }
        })
            .then((data: any) => {
                context.commit("SetLocalUserListList", data.data);
            });
    },
    GetLocalUserListForSMSFromServer(context: { commit: (arg0: string, arg1: any) => void; }) {
        axios.get("Task/GetAllForSmsCharge", {
 
        })
            .then((data: any) => {
                context.commit("SetLocalUserListForSMS", data.data);
            });
    },
    CheckUserSMS(context: { commit: (arg0: string, arg1: any) => void; }) {
        axios.get("Task/CheckUserSMS", {
 
        })
            .then((data: any) => {
                if (!data.data.isSuccess) {
                    func.showErrorMessage(data.data.message);
                    document.querySelectorAll(".btn_checkSmsm").forEach(el => el.remove());
                }
            });
    },
    UpdateUser(context: { commit: (arg0: string, arg1: boolean) => void; }, item: any) {
        context.commit("SetLoading", true);

        axios.post('Task/UpdateUser', item).then((response:any) => {
            console.log(response);
            if (response.status == 400 || response.data.success == false) {
                const res = response.data.errors.map((a: { errorMessage: any; }) => a.errorMessage);
                func.showErrorMessage(res.join('\n'));
            }
            else {
                func.showSuccessMessage("با موفقیت ثبت شد.");

                router.push('/LocalUserList');
            }
            context.commit("SetLoading", false);
        }, (error: any) => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },
    UpdateUserProfile(context: { commit: (arg0: string, arg1: boolean) => void; }, item: any) {
        context.commit("SetLoading", true);

        axios.post('Task/UpdateUserProfile', item).then((response:any) => {
            console.log(response);
            if (response.status == 400 || response.data.success == false) {
                const res = response.data.errors.map((a: { errorMessage: any; }) => a.errorMessage);
                func.showErrorMessage(res.join('\n'));
            }
            else {
                func.showSuccessMessage("با موفقیت ثبت شد.");

                router.go(0);
            }
            context.commit("SetLoading", false);
        }, (error: any) => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },
};

export default {
    state,
    getters,
    mutations,
    actions
};
